<template>
  <div class="cmp cmp-student-card-4">
    <div class="card-top">
      <img class="student-photo" :src="userAvatarDict[data.headPhoto || '00']">
      <div class="student-name">{{data.studentName}}</div>
      <div class="student-rate">
        总体评价：
        <x-star-bar type="warning" :size="24" fill :index="starInfo.teacherStar"
        @click="clickStarHandler('teacherStar',$event)"></x-star-bar>
      </div>
      <div class="evaluates-list">
        <div class="evaluates-item text-center" v-for="(v,i) in (data.taskEvaluates || [])" :key="i">
          <el-tag :type="v.starRating===-1?'danger':'primary'">{{v.taskName}}</el-tag>
          <p :class="v.starRating===-1?'text-danger':''">
            {{v.starRating===-1 ? '未评价' : `${v.starRating || 0}星`}}
          </p>
        </div>
      </div>
    </div>
    <el-row type="flex" :gutter="20">
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">信息意识</div>
          <div class="panel-body">
            <x-star-bar type="warning" :size="24" fill
            :index="starInfo.informationStar"
            @click="clickStarHandler('informationStar',$event)"></x-star-bar>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">计算思维</div>
          <div class="panel-body">
            <x-star-bar type="warning" :size="24" fill
            :index="starInfo.thinkingStar"
            @click="clickStarHandler('thinkingStar',$event)"></x-star-bar>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" :gutter="20">
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">数字化学习与创新</div>
          <div class="panel-body">
            <x-star-bar type="warning" :size="24" fill
            :index="starInfo.digitalStar"
            @click="clickStarHandler('digitalStar',$event)"></x-star-bar>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">信息社会责任</div>
          <div class="panel-body">
            <x-star-bar type="warning" :size="24" fill
            :index="starInfo.societyStar"
            @click="clickStarHandler('societyStar',$event)"></x-star-bar>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="projectEvaluateUpdate">提交评价</el-button>
    </el-row>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import publicUrl from '@/assets/js/interface'
import utils from '@/assets/js/utils.js'

export default {
  name: 'cmp-student-card-4',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    let starInfo = {
      teacherStar: -1,
      informationStar: -1,
      thinkingStar: -1,
      digitalStar: -1,
      societyStar: -1,
    }
    return {
      starInfo: utils.deepCopy(starInfo),
      starInfoTemp: utils.deepCopy(starInfo),
      loadingCount: 0
    }
  },
  computed: {
    ...mapState(['userAvatarDict']),
    ...mapGetters({
      classActive: 'classmanagement/classActive',
    }),
  },
  watch: {
    data: {
      handler (n) {
        this.$set(this.starInfo, 'teacherStar', n.teacherStar)
        this.$set(this.starInfo, 'informationStar', n.informationStar)
        this.$set(this.starInfo, 'thinkingStar', n.thinkingStar)
        this.$set(this.starInfo, 'digitalStar', n.digitalStar)
        this.$set(this.starInfo, 'societyStar', n.societyStar)
        this.starInfoTemp = utils.deepCopy(this.starInfo)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clickStarHandler (name, index) {
      this.starInfo[name] = index || 0
      // this.projectEvaluateUpdate()
    },
    projectEvaluateUpdate () {
      this.loadingCount++
      let params = {
        ...this.starInfo,
        classId: this.classActive.id,
        projectId: this.$route.query.projectId,
        studentId: this.data.studentId,
        starRating: this.starInfo.teacherStar,
      }
      this.$ajaxJson.post(publicUrl.projectEvaluateUpdate, params).then(res => {
        if (res.data.code === 0) {
          // this.$emit('update', params)
          this.$message.success('保存成功' || res.data.message)
        } else {
          this.starInfo = utils.deepCopy(this.starInfoTemp)
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.starInfo = utils.deepCopy(this.starInfoTemp)
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    },
    // projectEvaluateUpdate: utils.debounce(function () {
    //   this.loadingCount++
    //   let params = {
    //     ...this.starInfo,
    //     classId: this.classActive.id,
    //     projectId: this.$route.query.projectId,
    //     studentId: this.data.studentId,
    //     starRating: this.starInfo.teacherStar,
    //   }
    //   this.$ajaxJson.post(publicUrl.projectEvaluateUpdate, params).then(res => {
    //     if (res.data.code === 0) {
    //       this.$emit('update', params)
    //       this.$message.success('保存成功' || res.data.message)
    //     } else {
    //       this.starInfo = utils.deepCopy(this.starInfoTemp)
    //       this.$message.error(res.data.message)
    //     }
    //   }).catch(err => {
    //     this.starInfo = utils.deepCopy(this.starInfoTemp)
    //     this.$ajaxError(err)
    //   }).finally(() => {
    //     this.loadingCount--
    //   })
    // }, 2000),
  }
}
</script>

<style lang="less" scoped>
.cmp-student-card-4 {
  width: 584px;
  margin: 10px auto;
  padding: 20px;
  border: 1px solid #D1D8DD;
  border-radius: 6px;
  overflow: hidden;
  text-align: center;
  background-color: #fff;
  .student-photo {
    display: inline-block;
    width: 126px;
    height: 126px;
    border: 1px solid #CED2DA;
    border-radius: 50%;
  }
  .student-name {
    height: 28px;
    font-size: 20px;
    color: #464C5B;
    line-height: 28px;
  }
  .evaluates-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .evaluates-item {
      width: 96px;
      margin: 3px auto;
      p {
        font-size: .9em;
        line-height: 2;
      }
    }
  }
  .el-tag {
    margin: 0 10px;
  }
  .panel {
    background: #f5f5f5;
    margin: 10px auto;
    border-radius: 6px;
    .panel-header {
      height: 46px;
      font-size: 16px;
      color: #464C5B;
      line-height: 46px;
      border-bottom: 1px solid #D1D8DD;
    }
    .panel-body {
      height: 58px;
      .x-star-bar {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
      }
    }
  }
}
</style>
